import { DotsVerticalIcon } from "@heroicons/react/outline";
import { DropdownMenu } from "components/dropdownMenu";
import { SwitchButton } from "components/switchButton";
import moment from "moment";
import React from "react";
import { EwaiverType } from "routes/ewaiver/hooks/useEwaiver";
import { isHaveActionPermission } from "utills/helpers";

interface PropType {
  index: number;
  item: EwaiverType;
  pageSize: number;
  currentPage: number;
  _toggleActive: (item: EwaiverType) => void;
}

const ListCard = (props: PropType) => {
  const { index, item, pageSize = 10, currentPage = 1, _toggleActive } = props;

  return (
    <div className="w-full bg-white p-[16px] rounded-[8px]">
      <div className="w-full flex items-center justify-between">
        <SwitchButton
          checked={item?.is_have_online_checkin === 1}
          disabled={!isHaveActionPermission("", "e_waiver", "edit")}
          onChange={() => _toggleActive(item)}
        />

        <div className="flex items-center gap-[5px]">
          <div className="flex items-center justify-center bg-[#E9EDF1] rounded-[30px] px-[8px] py-[3px]">
            <span className="text-[14px] font-[500] text-[#262626]">
              No{" "}
              <span className="font-[400]">
                {(currentPage - 1) * pageSize + 1 + index}
              </span>
            </span>
          </div>

          <DropdownMenu
            label={<DotsVerticalIcon className="w-4" />}
            items={[
              {
                label: "View",
                href: `/ewaiver/detail/${item?.event_id}`,
                //   target: "_blank",
              },
              ...(isHaveActionPermission("", "e_waiver", "edit")
                ? [
                    {
                      label: "Edit",
                      href: `/ewaiver/edit/${item?.event_id}`,
                      //   target: "_blank",
                    },
                  ]
                : []),
              {
                label: "Tracking",
                onClick: () => {
                  console.log(`Tracking: ${item}`);
                },
                //   target: "_blank",
              },
              {
                label: "Log",
                onClick: () => {
                  console.log(`Log: ${item}`);
                },
                //   target: "_blank",
              },
            ]}
          />
        </div>
      </div>

      <div className="w-full mt-[16px] flex flex-col gap-[8px]">
        <div className="w-full flex">
          <span className="w-[30%] text-[14px] font-[500] text-[#262626] truncate">
            Event name
          </span>
          <span className="w-[70%] text-[14px] font-[400] text-[#2B3033] text-right">
            {item?.event_name_vi}
          </span>
        </div>

        <div className="w-full flex">
          <span className="w-[30%] text-[14px] font-[500] text-[#262626] truncate">
            Start Date Time
          </span>
          <span className="w-[70%] text-[14px] font-[400] text-[#2B3033] text-right">
            {item?.start_checkin_online_date
              ? moment(item?.start_checkin_online_date).format(
                  "DD/MM/YYYY HH:mm"
                )
              : ""}
          </span>
        </div>

        <div className="w-full flex">
          <span className="w-[30%] text-[14px] font-[500] text-[#262626] truncate">
            End Date Time
          </span>
          <span className="w-[70%] text-[14px] font-[400] text-[#2B3033] text-right">
            {item?.end_checkin_online_date
              ? moment(item?.end_checkin_online_date).format("DD/MM/YYYY HH:mm")
              : ""}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListCard;
